import { useEffect, useRef } from "react";

import { useAppDispatch } from "../../hooks/redux";
import { setCredentials } from "../../store/slices/authSlice";
import CustomSocialMediaButton from "../CustomSocialMediaButton";
import GoogleIcon from '../../assets/icons/Google.png';

import styles from  './GoogleButton.module.scss';

declare global {
  interface Window {
    google: any;
  }
}

const GoogleButton = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    window.google.accounts.id.initialize({
      client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID!,
      callback: handleCredentialResponse,
      ux_mode: 'popup',
    });
  }, []);

  const handleCredentialResponse = async (response: any) => {
    const credential = response.credential;
  
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/users/sign-in/google/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ google_token: credential }),
      });
  
      if (!res.ok) throw new Error('Login failed');
  
      const data = await res.json();
      dispatch(setCredentials({ ...data }));
      localStorage.setItem("authToken", data.access);
    } catch (err) {
      console.error('Login error:', err);
    }
  };

  const handleLoginClick = () => {
    window.google.accounts.id.prompt();
  };

  return (
    <CustomSocialMediaButton
      customStyle={styles.socialMediaButton}
      text='Continue with Google'
      icon={GoogleIcon}
      onClick={handleLoginClick}
    />
  );
};

export default GoogleButton;
